module.exports = __webpack_public_path__ + "img/pp1.36fba231.png";